/**
 * Shared limits for the hours segment of HH:MM in Aircraft Life-cycle TSR and related UIs.
 * Keep converter + validators + helper text aligned on one source of truth.
 */
export const MAX_HHMM_HOURS_DIGITS = 7;
export const MAX_HHMM_HOUR_COUNT = 10 ** MAX_HHMM_HOURS_DIGITS - 1;

/** Helper line for TextField helperText under Hours TSR inputs */
export const HHMM_LIMIT_HELPER_TEXT = `Format: HH:MM (hours: 0-${MAX_HHMM_HOUR_COUNT}, minutes: 0-59)`;
